import "./App.css";
import Router from "./router/router";
import { useSelector } from "react-redux";

function App() {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  console.log(isLoggedIn);
  

  return (
    <>
      <Router isLoggedIn={isLoggedIn} />
    </>
  );
}

export default App;
